import axios from 'axios';
import { USAGE_LABEL } from '@/constants';

const apiUsages = {
    get(params, idToken, cancelToken) {
        let headers = {
            Authorization: 'Bearer ' + idToken,
            'X-From': location.href
        };
        if (
            process.env.VUE_APP_ENV === 'local' ||
            process.env.VUE_APP_ENV === 'demo' ||
            process.env.VUE_APP_ENV === 'prototype'
        ) {
            if (Object.keys(USAGE_LABEL).includes(params.items)) {
                headers['x-api-fake-when-items'] = params.items;
            }
        }
        return axios
            .get(`${process.env.VUE_APP_APIURL}/usages`, {
                headers: headers,
                params: params,
                cancelToken: cancelToken
            })
            .catch(error => {
                throw error;
            });
    },
    count: {
        get(params, idToken, cancelToken) {
            let headers = {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            };
            if (
                process.env.VUE_APP_ENV === 'local' ||
                process.env.VUE_APP_ENV === 'demo' ||
                process.env.VUE_APP_ENV === 'prototype'
            ) {
                headers['x-api-fake-when-items'] = params.items;
            }
            return axios
                .get(`${process.env.VUE_APP_APIURL}/usages/count`, {
                    headers: headers,
                    params: params,
                    cancelToken: cancelToken
                })
                .catch(error => {
                    throw error;
                });
        }
    }
};
export default apiUsages;
